const formQuestions = {
  ebidtaSign: [
    {
      rows: [
        {
          title: 'Positivo',
          id: 'FQES00',
          index: 0,
          color: '#ffc000'
        },
        {
          title: 'Negativo',
          id: 'FQES01',
          index: 1,
          color: '#ffc000'
        },
        {
          title: 'Cero',
          id: 'FQES02',
          index: 2,
          color: '#ffc000'
        }
      ]
    }
  ],
  sellsPrediction: [
    {
      rows: [
        {
          title: 'Aumentan lo previsto',
          id: 'FQSP00',
          index: 0,
          color: '#0c9',
          colorFilterValues: {
            invert:'52',
            sepia:'96',
            saturate:'2266',
            hueRotate:'124',
            brightness:'97',
            contrast:'101',
          }
        },
        {
          title: 'Se mantienen como el año anterior',
          id: 'FQSP01',
          index: 1,
          color: '#0c9',
          colorFilterValues: {
            invert:'52',
            sepia:'96',
            saturate:'2266',
            hueRotate:'124',
            brightness:'97',
            contrast:'101',
          }
        },
        {
          title: 'Se reducen respecto al año anterior',
          id: 'FQSP02',
          index: 2,
          color: '#0c9',
          colorFilterValues: {
            invert:'52',
            sepia:'96',
            saturate:'2266',
            hueRotate:'124',
            brightness:'97',
            contrast:'101',
          }
        },
        {
          title: 'No tienen',
          id: 'FQSP03',
          index: 3,
          color: '#0c9',
          colorFilterValues: {
            invert:'52',
            sepia:'96',
            saturate:'2266',
            hueRotate:'124',
            brightness:'97',
            contrast:'101',
          }
        }
      ]
    }
  ],
  hasAccountAuditor: [
    {
      rows: [
        {
          title: 'Sí',
          id: 'FQHAA00',
          index: 0,
          color: '#cb1a07',
          colorFilterValues: {
            invert:'15',
            sepia:'63',
            saturate:'6861',
            hueRotate:'1',
            brightness:'91',
            contrast:'95',
          }
        },
        {
          title: 'En proceso de contratación',
          id: 'FQHAA01',
          index: 1,
          color: '#cb1a07',
          colorFilterValues: {
            invert:'15',
            sepia:'63',
            saturate:'6861',
            hueRotate:'1',
            brightness:'91',
            contrast:'95',
          }
        },
        {
          title: 'No',
          id: 'FQHAA02',
          index: 2,
          color: '#cb1a07',
          colorFilterValues: {
            invert:'15',
            sepia:'63',
            saturate:'6861',
            hueRotate:'1',
            brightness:'91',
            contrast:'95',
          }
        }
      ]
    }
  ]
}

export default formQuestions
